import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'groupBy',
    pure: true // Ensure the pipe is pure
})
export class GroupByPipe implements PipeTransform {
    private cachedResults: Map<string, any[]> = new Map<string, any[]>(); // Store cached results

    transform(collection: any[], properties: string[]): any[] {
        if (!collection) {
            return null;
        }

        // Generate cache key based on properties
        const cacheKey = properties.join(',');

        // Check if the result is already cached
        if (this.cachedResults.has(cacheKey)) {
            return this.cachedResults.get(cacheKey);
        }

        // If not cached, compute and cache the result
        const groupedCollection = collection.reduce((acc, obj) => {
            const key = properties.map(property => obj[property]).join('-');
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(obj);
            return acc;
        }, {});

        // Map the grouped collection into array of key-value pairs
        const transformedResult = Object.keys(groupedCollection).map(key => ({ key, value: groupedCollection[key] }));

        // Cache the result
        this.cachedResults.set(cacheKey, transformedResult);

        return transformedResult;
    }
}
